module.exports = __webpack_public_path__ + "img/wechat.66c6286c.png";